import { withStyles } from "@material-ui/core";
import colors from "../styleColors";
const styles = () => ({
  legendContainer: {
    marginTop: 12,
    display: "flex",
    flexWrap: "wrap",
    maxWidth: "95%",
  },
  legendWrapper: {
    display: "flex",
    alignItems: "center",
    margin: 2,
  },
  legendLabel: {
    width: 50,
    fontSize: 9,
    color: "#778899",
    fontWeight: 600,
    marginLeft: 8,
  },
  legendIconStop: {
    width: 15,
    height: 15,
    border: `2px solid ${colors.greyBorderColor}`,
    borderRadius: "2px",
  },
  legendIconClkInTime: {
    width: 6,
    height: 20,
    borderRadius: "2px",
    background: "#00A7E1",
  },
  legendIconClkOutTime: {
    width: 6,
    height: 20,
    borderRadius: "2px",
    background: colors.lightGrey,
  },
  legendIconGateInTime: {
    width: 6,
    height: 20,
    borderRadius: "2px",
    background: colors.greyBorderColor,
  },
  legendIconDispatchTime: {
    width: 6,
    height: 20,
    borderRadius: "2px",
    background: "#227270",
  },
  legendIconGateOutTime: {
    width: 6,
    height: 20,
    borderRadius: "2px",
    background: colors.primaryAppColor,
  },

  legendIconBreak: {
    width: 15,
    height: 15,
    border: "2px solid #F5A623",
    borderRadius: "2px",
    background: "rgba(245, 166, 35, 0.4)",
  },
  legendIconDwellTime: {
    width: 15,
    height: 15,
    border: "2px solid #DE4045",
    borderRadius: "2px",
    background: "rgba(222, 64, 69, 0.4)",
  },
  legendIconRestBreak: {
    width: 15,
    height: 15,
    border: "2px solid #CB9208",
    borderRadius: "2px",
    background: "#ECD59E",
  },
});

const GANTT_LEGENDS = [
  {
    className: "legendIconClkInTime",
    label: "Clock In",
  },
  {
    className: "legendIconClkOutTime",
    label: "Clock Out",
  },
  {
    className: "legendIconGateOutTime",
    label: "Gate Out",
  },
  {
    className: "legendIconGateInTime",
    label: "Gate In",
  },
  {
    className: "legendIconDispatchTime",
    label: "Dispatch Time",
  },
  {
    className: "legendIconStop",
    label: "Time at Stop",
  },
  {
    className: "legendIconBreak",
    label: "Break",
  },
  {
    className: "legendIconDwellTime",
    label: "Extra Stop Time",
  },
  {
    className: "legendIconRestBreak",
    label: "Rest Break",
  },
];

const DriverPerformanceLegend = ({ classes }) => (
  <div className={classes.legendContainer}>
    {GANTT_LEGENDS.map((item, index) => {
      return (
        <div
          key={`${item.className}_${index}`}
          className={classes.legendWrapper}
        >
          <div className={classes[item.className]}></div>
          <div className={classes.legendLabel}>{item.label}</div>
        </div>
      );
    })}
  </div>
);

export default withStyles(styles)(DriverPerformanceLegend);
